import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { roundToDecimal } from "../../../../../../utils/helper/utils";
const SalesByItem = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [paginationModel] = useState(paginationLimit); //setPaginationModel
  const [dataSource, setDataSource] = useState([]);

  const getAllReportsByItem = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_ITEM, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse?.data?.items) {
          let resultData = [];
          for (let key in apiResponse?.data?.items) {
            let item = apiResponse?.data?.items[key];
            resultData.push({
              key: key,
              productId: item.productId,
              productName: item.productName,
              totalQuantitySold: item.totalQuantitySold,
              totalAmount: roundToDecimal(item.totalAmount, 2),
              averagePrice: roundToDecimal(item.averagePrice, 2),
              orders: [],
            });
          }
          setDataSource(resultData);
        }
        // setTotalRows(apiResponse?.data?.itemCount);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReportsByItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
    title: "ID",
    dataIndex: "productId",
    key: "productId",
    sorter: (a, b) => a.productId - b.productId,
    render: (text) => text || "-"
  },
    {
      title: "Item name",
      dataIndex: "productName",
      key: "name",
    },
    {
      title: "Total quantity sold",
      dataIndex: "totalQuantitySold",
      key: "TotalQuantity",
      //  to={"/item-order/" + record?.productId}
      render: (text, record) => (
        <Typography
          onClick={() => {
            navigate(`/item-order/${record?.productId}`, { state: { inputData: inputData, tabIndex: tabIndex } });
          }}
          className="cursor-pointer text-[#176B53]"
        >
          {text}
        </Typography>
      ),
    },
    {
      title: "Total amount",
      dataIndex: "totalAmount",
      key: "TotalAmount",
    },
    {
      title: "Average price",
      dataIndex: "averagePrice",
      key: "AveragePrice",
    },
  ];

  return <Table columns={columns} dataSource={dataSource} className="multi-tables responsive" />;
};

export default SalesByItem;
